import { useTypedTranslations } from '../translation/use-translations';
import SportsbookUnavailable from './components/sportsbook-unavailable';

enum TextKeys {
	HEADER_LABEL = 'SPORTSBOOK_MAINTENANCE_HEADER_LABEL',
	DESCRIPTION_LABEL = 'SPORTSBOOK_MAINTENANCE_DESCRIPTION_LABEL'
}

const SportsbookMaintenance = () => {
	const { isLoadingTranslations, translations } = useTypedTranslations(TextKeys);

	if (isLoadingTranslations) {
		return null;
	}

	return (
		<SportsbookUnavailable
			title={translations[TextKeys.HEADER_LABEL]}
			description={translations[TextKeys.DESCRIPTION_LABEL]}
		/>
	);
};

export default SportsbookMaintenance;
